/**
 * Finds the offset parent of an HTML element.
 */
const getOffsetParent = (element: HTMLElement | null) => {
  if (element === null) return document.documentElement
  let el = element
  let offsetParent = el.offsetParent as HTMLElement
  while (!offsetParent && el.nextElementSibling) {
    el = el.nextElementSibling as HTMLElement
    offsetParent = el.offsetParent as HTMLElement
  }
  return offsetParent == null || offsetParent.nodeName === "BODY"
    ? document.documentElement
    : offsetParent
}

export default getOffsetParent
